module.exports = __webpack_public_path__ + "static/gallery_wild_2-aea430765db3c63c90c7967e18e12cd4.jpg";